import { useEffect, useRef, useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import CustomStyledTable from "../../../../../components/table/CustomStyledTable";
import { Columns } from "./data";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import CurrenciesModalForm from "./modal";
import DeleteModal from "../../../../../components/modals/DeleteModal";
import ActionPopover from "../../../../../components/popovers/actionPopover";
import {
	useDeleteCurrency,
	useGetCurrency,
	useGetCurrencySearch,
} from "../../../../../services/currency.service";
import useEditFormStore from "../../../../../state-management/useEditFormStore";
import {
	useManageTableWithSearchParams,
	useManageTableWithSearchParamsData,
} from "../../../../../helpers/useManageTable";
import { CurrencyDto } from "../../../../../models/currency.dto";
import TableFilter from "../../../../../components/table/filter/TableFilter";
import APISearchInput from "../../../../../components/search/APISearchInput";
import { CurrencyColumns } from "./tanstack-columns";
import TanStackEmployeeTable from "../../../../../components/table/TanStackEmployeeTable";
import { useTableConfiguration } from "../../../../../helpers/useTableConfiguration";
import { TableId } from "../../../../../models/table-configuration.dto";
import useUserStore from "../../../../../state-management/useUserStore";

const Currencies = () => {
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
	const [openModal, setOpenModal] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [isEditForm, setIsEditForm] = useState(false);
	const currentUser = useUserStore().currentUser.user;

	const { mutate: searchCurrencies } = useGetCurrencySearch();
	const {
		tableAPIRef,
		fetchedTableData,
		tableData,
		isLoading,
		pageCount,
		setTableData,
	} = useManageTableWithSearchParams<CurrencyDto>({
		fetchHook: useGetCurrency,
	});

	const handleClose = () => setAnchorEl(null);
	const handleOpenModal = () => {
		setAnchorEl(null);
		setIsEditForm(false);
		setOpenModal(true);
	};

	const { formDataValues, setFormData } = useEditFormStore();
	const [deleting, setDeleting] = useState(false);
	const { mutate: deleteCurrency } = useDeleteCurrency();
	const { reloadTableData } = useManageTableWithSearchParamsData();

	const handleDeleteMethod = () => {
		setDeleting(true);

		deleteCurrency(
			{ id: formDataValues?.id },
			{
				onSuccess: () => {
					reloadTableData();
					setOpenDeleteModal(false);
				},
				onSettled: () => setDeleting(false),
			},
		);
	};

	const additionalColumns = [
		{
			field: "actions",
			type: "actions",
			headerName: "Actions",
			minWidth: 150,
			flex: 1,
			headerClassName: "super-app-theme--header",
			cellClassName: "actions ",
			getActions: (params: any) => {
				return [
					<GridActionsCellItem
						icon={<BiDotsHorizontalRounded />}
						label="actions"
						onClick={(e: any) => {
							// console.log(params.row, "params");
							setFormData(params?.row);
							setAnchorEl(e.currentTarget);
						}}
					/>,
				];
			},
		},
	];
	const columnsWithAdditions = Columns.map(
		(obj) => additionalColumns.find((o) => o.field === obj.field) || obj,
	);

	return (
		<div>
			<h2 className="text-2sm font-semibold mb-3">Currencies</h2>
			<hr />
			<div className="flex justify-between items-center mt-7 mb-8">
				<div className="flex items-center gap-3">
					<APISearchInput
						fallbackData={fetchedTableData}
						setTableData={setTableData}
						mutate={searchCurrencies}
					/>
					<TableFilter
						fields={[
							{
								title: "",
								fieldName: "",
								fieldType: "SORT",
								options: [
									{
										title: "Name",
										fieldName: "name",
									},
									{
										title: "Date Created",
										fieldName: "createdAt",
									},
								],
							},
							{
								title: "Active",
								fieldName: "active",
								fieldType: "YES_NO",
							},
							{
								title: "Default",
								fieldName: "isDefault",
								fieldType: "YES_NO",
							},
						]}
					/>
				</div>
				<div
					className="flex items-center text-primary-blue text-sm cursor-pointer"
					onClick={handleOpenModal}
				>
					<AiOutlinePlus className="mr-1 text-sm" />
					Add New Currency
				</div>
			</div>
			<TanStackEmployeeTable
				tableId={TableId.CURRENCIES}
				data={tableData}
				columns={CurrencyColumns}
				loading={isLoading}
				onRowClick={(row, event) => {
					setFormData(row);
					setAnchorEl(event.currentTarget);
				}}
				onActionClick={(row, event) => {
					setFormData(row);
					setAnchorEl(event.currentTarget);
				}}
				initialColumnVisibility={{}}
				pageSize={10}
				pageCount={pageCount}
				apiRef={tableAPIRef}
			/>
			{/* <CustomStyledTable
				rows={tableData}
				columns={columnsWithAdditions}
				apiRef={tableAPIRef}
				loading={isLoading}
				pageCount={pageCount}
				setAnchorEl={setAnchorEl}
			/> */}
			<ActionPopover
				id={anchorEl ? "simple-popover" : undefined}
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				handleClose={handleClose}
				setOpenDeleteModal={setOpenDeleteModal}
				setOpenEdit={setIsEditForm}
				setOpenModal={setOpenModal}
			/>
			<DeleteModal
				openDeleteModal={openDeleteModal}
				spanContent={formDataValues?.name || ""}
				setOpenDeleteModal={setOpenDeleteModal}
				handleDeleteMethod={handleDeleteMethod}
				deleting={deleting}
			/>
			{openModal && (
				<CurrenciesModalForm
					open={openModal}
					setOpen={setOpenModal}
					title={isEditForm ? "Update Currency" : "Add New Currency"}
					isEditForm={isEditForm}
					tableAPIRef={tableAPIRef}
					reloadTableData={reloadTableData}
				/>
			)}
		</div>
	);
};

export default Currencies;
